module.exports = require('./helpers/bundle-url').getBundleURL('8a2ir') + "logo-dark.eefe0b7f.svg";